import {
  AfterViewChecked, AfterViewInit, Component, ElementRef, Inject, Renderer2, ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LayoutBaseRenderComponent } from 'render/render-shared/layout-base-render/layout-base-render.component';
import { RenderSeoService } from 'render/services/render-seo.service';
import { fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { LayoutHeaderFooterSettings } from './models/layout-header-footer.models';


@Component({
  selector: 'layout-header-footer-render',
  templateUrl: './layout-header-footer-render.component.html',
  styleUrls: ['./layout-header-footer-render.component.scss']
})
export class LayoutHeaderFooterRenderComponent
  extends LayoutBaseRenderComponent<LayoutHeaderFooterSettings>
  implements AfterViewChecked, AfterViewInit {

  public stickyFooter: boolean = false;

  @ViewChild('rollingHeader', { read: ElementRef })
  private readonly rollingHeader?: ElementRef<HTMLDivElement>;

  @ViewChild('header', { read: ElementRef })
  private readonly header?: ElementRef<HTMLDivElement>;

  @ViewChild('headerOverlap', { read: ElementRef })
  private readonly headerOverlap?: ElementRef<HTMLDivElement>;

  constructor(
    protected readonly route: ActivatedRoute,
    protected readonly seoService: RenderSeoService,
    @Inject('Window') private readonly window: Window,
    private readonly renderer: Renderer2
  ) {
    super(route, seoService);
  }

  public ngAfterViewInit() {
    const rollingHeader = this.renderer.selectRootElement(this.rollingHeader)
      ?.nativeElement;
    const header = this.renderer.selectRootElement(this.header)?.nativeElement;
    const headerOverlap = this.renderer.selectRootElement(this.headerOverlap)?.nativeElement;
    fromEvent(document, 'scroll').pipe(
      takeUntil(this.clearSubscriptions$)
    ).subscribe(() => {
      if (this.window.pageYOffset < rollingHeader.clientHeight) {
        header.style.top = `${rollingHeader.clientHeight - this.window.pageYOffset}px`;
        headerOverlap.style.top = `${rollingHeader.clientHeight + header.clientHeight - this.window.pageYOffset}px`;
      } else if (header.style.top !== '0px') {
        header.style.top = '0px';
        headerOverlap.style.top = `${header.clientHeight}px`;
      }
    });
  }

  public ngAfterViewChecked() {
    const rollingHeader = this.renderer.selectRootElement(this.rollingHeader)
      ?.nativeElement;
    const header = this.renderer.selectRootElement(this.header)?.nativeElement;
    const headerOverlap = this.renderer.selectRootElement(this.headerOverlap)?.nativeElement;
    if (rollingHeader.style.marginBottom !== `${header.clientHeight}px`) {
      rollingHeader.style.marginBottom = `${header.clientHeight}px`;
    }
    if (
      this.window.pageYOffset === 0
      && header.style.top !== rollingHeader.clientHeight
    ) {
      header.style.top = `${rollingHeader.clientHeight}px`;
      headerOverlap.style.top = `${rollingHeader.clientHeight + header.clientHeight}px`;
    }
  }

  protected onInitHook(): void {
    this.stickyFooter = (this.layout?.settings?.general?.stickyFooter as boolean | undefined) ?? false;
  }

}
